import * as React from 'react';

const Typography = () => {
  return (
    <div>
      <h1>Heading 1 - Desktop: 36/43, Mobile: 28/36 </h1>
      <h3>Heading 3 - Desktop: 32/38, Mobile: 28/36 </h3>
      <h2>Heading 2 - Desktop: 24/29, Mobile: 18/23 </h2>
      <p className='text-lg'>Text Large - Desktop: 20/24, Mobile: 16/21</p>
      <p>Text Medium (default) - Desktop: 18/27, Mobile: 14/20</p>
    </div>
  );
};

export default Typography;
